import { Box } from "@mui/material";
import React from "react";
import liquestoreMaintenance from "../assets/liquestoreMaintenance.png";
import liquestoreMaintenancePhone from "../assets/liquestoreMaintenancePhone.png";

const MaintenancePage = () => {
	return (
		<Box
			sx={{
				width: "100%",
				lineHeight: 0,
			}}
		>
			<picture>
				<source media="(max-width: 899px)" srcSet={liquestoreMaintenancePhone} />
				<img
					src={liquestoreMaintenance}
					alt="Liquestore maintenance"
					style={{
						display: "block",
						width: "100%",
						height: "auto",
					}}
				/>
			</picture>
		</Box>
	);
};

export default MaintenancePage;
